module.exports = __webpack_public_path__ + "img/blue.126e5ff9.png";